import { render, staticRenderFns } from "./IconElementSubheadline.vue?vue&type=template&id=83e0fd84&"
import script from "./IconElementSubheadline.vue?vue&type=script&lang=js&"
export * from "./IconElementSubheadline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83e0fd84')) {
      api.createRecord('83e0fd84', component.options)
    } else {
      api.reload('83e0fd84', component.options)
    }
    module.hot.accept("./IconElementSubheadline.vue?vue&type=template&id=83e0fd84&", function () {
      api.rerender('83e0fd84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconElementSubheadline.vue"
export default component.exports